export const LOCAL_PHONE_NUMBERS = 1
export const TOLL_FREE_NUMBERS = 2
export const MOBILE_PHONE_NUMBERS = 3
